export const loadingStatus = {
    NOT_STARTED: -1,
    IS_LOADING: 0,
    SUCCESS: 1,
    ERROR: 2
}

export const isLoading = status => {
    return status === loadingStatus.IS_LOADING;
}

export const isReadyToLoad = status => {
    return status === loadingStatus.NOT_STARTED;
}

export const isError = status => {
    return status === loadingStatus.ERROR;
}

export const isSuccess = status => {
    return status === loadingStatus.SUCCESS;
}